import { deleteCall, getCall, postCall, putCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

// HANDOFF METHODS
export const changeSchedule = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/handoff/schedule/" + bot_id, {
    schedule: data,
  });
  if (res[0]) {
    updateToast(id, "success", "Horarios guardados correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar los horarios.");
    return null;
  }
};

export const getHandOffData = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/handoff/" + bot_id);
  if (res[0]) {
    return res[0].handoff_options;
  } else return null;
};

export const getHandOffbyAreas = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/handoff/areas/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const changeHandOffState = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/handoff/" + bot_id);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const toggleHandoffArea = async (id) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/handoff/areas/" + bot_id + "/" + id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const toggleOnlyLiveChatConfig = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/handoff/toggle/only-live-chat/" + bot_id);
  if (res[0]) {
    return res[0].only_handoff_mode;
  } else {
    return null;
  }
};

// HANDOFF EXCEPTIONS METHODS
export const getHandoffExceptions = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/handoff-exceptions/" + bot_id);
  if (res[0]) {
    console.log(res);
    return res[0].handoff_exceptions;
  } else return null;
};

export const addHandoffException = async (handoffException) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/handoff-exceptions/" + bot_id,
    {
      title: handoffException.title,
      date: handoffException.date,
      message: handoffException.message,
    }
  );

  if (res[0]) {
    updateToast(id, "success", "Excepción agregada con éxito.");
    return res[0].handoff_exception;
  } else {
    dispatchErrorMessage(id, res, "Error al agregar la excepción.");
    return null;
  }
};

export const deleteHandoffException = async (exceptionId) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/handoff-exceptions/" + bot_id + "/" + exceptionId);
  if (res) {
    updateToast(id, "success", "Excepción eliminada con éxito.");
    return true;
  }
  dispatchErrorMessage(id, res, "Error al eliminar la excepción.");
  return false;
};